import React, { useRef, useState } from 'react';
import { injectIntl } from 'react-intl';
import { adaptGameToContainer, formatNumber, getRemotedbUrl, i18nIntl, isNotEmpty } from '../../lib/ep.js';
import { useCSS } from '../../lib/hooks.js';
import { useCanvasMachine } from '../../ts/games/canvasStateMachine.ts';

import ActionLink from '../builder/ActionLink.js';
import { localizeFields } from '../builder/DynamicFields.js';
import { uploadImage } from '../builder/ImageUploader.js';

import LeveledHTMLText from './helpers/LeveledHTMLText.js';

import OneTimeBracketCanvas from '../games/OneTimeBracketCanvas.js';

import FaceOffStats from './FaceOffStats.js';
import { getFullImage, getTeamInfoByID, getTeamName } from './GuessScoreClient.js';
import MisconfiguredGameWarning from './MisconfiguredGameWarning.js';
import { checkMatchesFirstRound } from './OneTimeBracketClient.js';
import ShareGameFinal from './ShareGameFinal.js';
import ToggleButton from '../builder/ToggleButton.js';

export const OneTimeBracketPointsDetail = ({...props}) =>{
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const display_results = !(props?.hide ?? true);
	const stage = props.stage;
	let previous_index = 0;

	const grouped_matches = [];
	const rounds = stage?.guess_score_rounds ?? [];
	const total_rounds = parseInt(stage?.guess_score_num_rounds ?? '4');
	[...Array(total_rounds).keys()].map((round, r) => {
		const num_matches_in_round = Math.pow(2, (total_rounds - r - 1));

		const matches_in_round = [];
		for(let i = 0; i < num_matches_in_round; i++) {
			matches_in_round.push(i + previous_index);
		}

		grouped_matches.push({
			label:`${(isNotEmpty(rounds[r], 'title') ? rounds[r].title : i18n("Round", 'uppercase'))}`,
			matches:matches_in_round,
		});
		previous_index += num_matches_in_round;
	});
	const matches = stage?.guess_score_matches ?? {};
	const results = stage?.guess_score_matches_result ?? {};
	const answers = props.answers;
	const teams = props.promotion.guess_score_teams;
	const points_x_round = stage.guess_score_points_outcome;
	
	if(!display_results)return false;

	return (

		<ul class="list" style={{fontSize:'1em'}}>
			{(grouped_matches).map((group, i) =>{
				const number_round = i + 1;
				let points_in_round = 0;
				let has_results_in_round = false;
				let text = '';
				matches.map((match,index) =>{
					if((group?.matches ?? []).includes(index)){
						if(['1','2'].includes(results?.[match.id]?.winner ?? '')){//has result
							const winner_id = match[`id_${results[match.id].winner}`]
							const team_info_a = getTeamInfoByID(teams,match.id_1)
							const team_info_b = getTeamInfoByID(teams,match.id_2)
							let points_match = 0;
							const winner_a = winner_id == match.id_1;
							const winner_b = winner_id == match.id_2;
							const label_winner_a = winner_a ? team_info_a.name : `<span class="gui_stroked_text">${team_info_a.name}</span>`
							const label_winner_b = winner_b ? team_info_b.name : `<span class="gui_stroked_text">${team_info_b.name}</span>`
							text += `· ${label_winner_a} - ${label_winner_b} `;
							if(answers[match.id].winner == winner_id){
								points_match = points_x_round*number_round;
								if(match.x2 == true){
									text += ` (x2)`
									points_match = points_match * 2;
								}
							}
							text += `: ${formatNumber(points_match,2)} ${i18n('points')}<br/>`
							points_in_round += points_match;
							has_results_in_round = true;
						}
					}
				})
				if(!has_results_in_round)return null;
				return (
					<li style={{fontSize:'1em'}} class="gui_not_in_bottom">
						<div class="gui_force_xbold gui_not_in_bottom_tiny ">{group.label}</div>
						<div class="gui_force_roman" dangerouslySetInnerHTML={{__html:text}}/>
						{/*<div class="gui_not_in_top_tiny gui_not_in_bottom_small" dangerouslySetInnerHTML={{__html:`${i18n("Total")}: <strong>${formatNumber(points_in_round,2)} ${i18n('points')}</strong>`}}/>*/}
					</li>
				)
			})}
		</ul>

	)
} 

const OneTimeBracketFinal = ({ stage, ...props }) => {
	useCSS('comp/guess_score.css');

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promotion = props?.promotion?.Promotion ?? (props?.promotion ?? {});
	const is_builder = props?.is_builder ?? false;
	const only_contents = props?.only_contents ?? false;
	const enable_actions = props?.enable_actions ?? true;

	const cnv = useRef(null);
	const uploaded = useRef(false);

	const matches = stage?.guess_score_matches ?? [];
	const num_rounds = parseInt(stage?.guess_score_num_rounds ?? '4');

	const teams = localizeFields(JSON.parse(JSON.stringify(promotion?.guess_score_teams ?? [])), props.locale);

	const findTeamById = (id) => {
		return teams.find((t) => (t.id == id));
	};

	const teams_for_stats = [];
	matches.map((match, m) => {
		if(m > Math.pow(2, num_rounds) / 2 - 1) return;

		const team_1 = findTeamById(match.id_1);
		const team_2 = findTeamById(match.id_2);

		teams_for_stats.push({
			...team_1,
			full_image:getFullImage(team_1, 'small'),
		});

		teams_for_stats.push({
			...team_2,
			full_image:getFullImage(team_2, 'small'),
		});
	});

	const main_description_placeholder = `<h1>${i18n("Thank you")}</h1><p>${i18n("Here are the statistics for each match.")}</p>`;
	const final_message = (isNotEmpty(stage, 'final_message')) ? stage.final_message : main_description_placeholder;

	const canvas_images = () => {
		const images = [];

		if(isNotEmpty(stage, 'guess_score_bracket_bg_image')) {
			images.push({
				id:'bracket_bg_image',
				name:stage.guess_score_bracket_bg_image,
				url:stage.full_guess_score_bracket_bg_image,
				fit:'cover',
			})
		}

		matches.map((match) => {
			const team_1 = findTeamById(match.id_1);
			const team_2 = findTeamById(match.id_2);

			if(team_1 != undefined) {
				images.push({
					id:`logo_${team_1.id}`,
					name:(isNotEmpty(team_1, 'short_name')) ? team_1.short_name : team_1.name,
					url:getFullImage(team_1),
					fit:'contain',
					get_average_color:true,
				});

				images.push({
					id:`logo_${team_1.id}_small`,
					name:`${(isNotEmpty(team_1, 'short_name')) ? team_1.short_name : team_1.name} (small)`,
					url:getFullImage(team_1, 'small'),
					fit:'contain',
				});
			}

			if(team_2 != undefined) {
				images.push({
					id:`logo_${team_2.id}`,
					name:(isNotEmpty(team_2, 'short_name')) ? team_2.short_name : team_2.name,
					url:getFullImage(team_2),
					fit:'contain',
					get_average_color:true,
				});

				images.push({
					id:`logo_${team_2.id}_small`,
					name:`${(isNotEmpty(team_2, 'short_name')) ? team_2.short_name : team_2.name} (small)`,
					url:getFullImage(team_2, 'small'),
					fit:'contain',
				});
			}
		});

		return images;
	};

	const [ state, dispatch ] = useCanvasMachine({
		images:canvas_images,
		images_dependencies:[
			stage.bg_image,
			stage.guess_score_matches,
		],
	});

	if(state.state != 'LOADED') return null;

	const download = () => {
		const image = cnv.current.to_image('base64');
		var a = document.createElement('a');
		a.href = image;
		a.download = "my_choice.jpg";
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	};

	const generateShare = () => {
		if(state.state != 'LOADED') return;
		if(uploaded.current) return;

		uploadImage(getRemotedbUrl(`/stages/upload/${stage.id}`), cnv.current.to_image(), (result) => {
			uploaded.current = true;
		}, { id:props.user_data.uid });
	};

	const default_props = {
		is_bracket:true,
		indexed_images:state.images,
		loaded_status:state.state,
		locale:props?.locale,
	};

	const display_stats = stage?.guess_score_display_stats ?? true;

	const min_teams = Math.pow(2, num_rounds);
	const missing_matches = checkMatchesFirstRound(matches, num_rounds);

	let missing_anything = false;
	let missing_anything_text = "";
	if(teams.length < min_teams) {
		missing_anything = 'teams';
		missing_anything_text = props.intl.formatMessage({ id:"Create at least {num} teams" }, { num:min_teams });
	} else if(missing_matches > 0) {
		missing_anything = 'matches';
		missing_anything_text = (missing_matches > 1) ? props.intl.formatMessage({ id:"There are still {num} uncomplete matches in first round" }, { num:missing_matches }) : i18n("There is still 1 uncomplete match in first round");
	}
	
	if(only_contents) {
		return (
			<div class="game_final_state in_bottom">
				<div class="gui_not_in_top gui_pos_rel final_image" style={{ maxWidth:'unset' }}>
					<OneTimeBracketCanvas
						ref={cnv}
						{...default_props}
						stage={stage}
						teams={teams}
						answers={props?.user_answer?.guess_score ?? (props?.answers ?? {})}
						matches={matches}
						is_standalone={true}
						adaptToContainer={adaptGameToContainer}
						is_builder={is_builder}
					/>

					{(enable_actions) && (
						<div class="final_ctas">
							<ShareGameFinal
								stage={stage}
								onOpenLayer={generateShare}
								promotion={props?.promotion?.Promotion ?? (props?.promotion ?? {})}
								result={props?.user_data ?? props?.user}
								is_builder={is_builder}
								custom_cta_props={{
									cta_type:'link',
								}}
								locale={props.locale}
								intl={props.intl}
							/>

							<ActionLink
								onClick={download}
							>Download</ActionLink>
						</div>
					)}
				</div>
			</div>
		)
	}

	return (
		<div class={`game_final_state${(is_builder) ? ' in_builder' : ''}`}>
			{(final_message != " ") && (
				<LeveledHTMLText>{final_message}</LeveledHTMLText>
			)}

			<div class="gui_not_in_top gui_pos_rel final_image" style={{ maxWidth:'unset' }}>
				{(missing_anything === false) ? (
					<OneTimeBracketCanvas
						ref={cnv}
						{...default_props}
						stage={stage}
						teams={teams}
						user_answer={props?.user_answer ?? []}
						matches={matches}
						is_standalone={true}
						adaptToContainer={adaptGameToContainer}
						is_builder={is_builder}
					/>
				) : (
					<div style={{ aspectRatio:'1 / 1' }}>
						<MisconfiguredGameWarning
							message={missing_anything_text}
							autotranslate={false}
						/>
					</div>
				)}

				{(enable_actions) && (
					<div class="final_ctas">
						<ShareGameFinal
							stage={stage}
							onOpenLayer={generateShare}
							promotion={props?.promotion?.Promotion ?? (props?.promotion ?? {})}
							result={props.user_data}
							is_builder={is_builder}
							custom_cta_props={{
								cta_type:'link',
							}}
							locale={props.locale}
							intl={props.intl}
						/>

						<ActionLink
							onClick={download}
						>Download</ActionLink>
					</div>
				)}
			</div>

			{(display_stats !== false) && (
				<FaceOffStats
					stage={stage}
					players={teams_for_stats}
					user_answer={props?.user_answer ?? []}
					max_items={stage?.guess_score_stats_count ?? '3'}
					stats={props?.stats ?? []}
					is_builder={props.is_builder}
					intl={props.intl}
				/>
			)}
		</div>
	);
};

export const OneTimeBracketFinalWithPoints = ({ stage, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const [view_detail, setViewDetail] = useState(false);
	return (
		<>
		{(isNotEmpty(props.user, 'quiz_result')) && (
			<div class="gui_flexbox_auto">
				{i18n("Score")}: <strong class="gui_not_in_start_micro">{formatNumber(props.user.quiz_result,2)} {i18n("points")}</strong>

				{(window.features.includes('one_bracket_detail')) && (
					<div class="detail">
						<ToggleButton
							active={view_detail}
							onClick={() => setViewDetail(!view_detail)}
							color={false}
							icon='knk-arrow-t-big'
							icon_off='knk-arrow-b-big'
						/>
					</div>	
				)}	
			</div>
		)}

		<OneTimeBracketPointsDetail
			stage={stage}
			hide={!view_detail}
			{...props}
		/>
		<OneTimeBracketFinal
			stage={stage}
			{...props}
		/>
		</>
	)
};

export default injectIntl(OneTimeBracketFinal);